import React, {memo} from 'react';
import FbIcon from "assets/images/services/fb.svg";
import FbIconSmall from "assets/images/services/fb-small.svg";
import GoogleServ from "assets/images/services/google-serv.svg";
import GoogleSmall from "assets/images/services/google-small.svg";
import YandexServ from "assets/images/services/yandex-serv.svg";
import YandexSmall from "assets/images/services/yandex-small.svg";
import TitTokSmall from "assets/images/services/tiktok-small.svg";
import TitTok from "assets/images/services/tiktok.svg";
import i18next from "i18next";

export const ServiceIdType = {
  Google: 1,
  G: 1,
  Facebook: 3,
  F: 3,
  TikTok: 4,
  TT: 4,
  Yandex: 5,
  YA: 5,
}


export const serviceName = Object.freeze({
  Google: "Google",
  Facebook: "Facebook",
  TikTok: "TikTok",
  Yandex: "Yandex Direct"
});
export const ServiceTypesImg = (serviceType, t = i18next.t, width = "auto", height = 16, isBig = true) => {
  switch (serviceType) {
    case 1:
    case "G":
      return <img src={isBig ? GoogleServ : GoogleSmall} alt={"google service"} width={width} height={height}/>
    case 5:
    case "YA":
      return <img src={isBig ? YandexServ : YandexSmall} alt={"yandex direct service"} width={width} height={height}/>
    case "F":
    case 3:
      return <img src={isBig ? FbIcon : FbIconSmall} alt={"facebook service"} width={width} height={height}/>
    case "TT":
    case 4:
      return <img src={isBig ? TitTok : TitTokSmall} alt={"TitTok service"} width={width} height={height}/>
    case null:
      return <div className={"font-weight-medium"}>{t("total")}</div>
    default:
      return ""
  }
}

export const ServiceTypeImgSmall = ({serviceType, width = "auto", height = 16}) => {
  switch (serviceType) {
    case 1:
    case "G":
      return <img src={GoogleSmall} alt={"google service"} width={width} height={height}/>
    case 5:
    case "YA":
      return <img src={YandexSmall} alt={"yandex direct service"} width={width} height={height}/>
    case "F":
    case 3:
      return <img src={FbIconSmall} alt={"facebook service"} width={width} height={height}/>
    case "TT":
    case 4:
      return <img src={TitTokSmall} alt={"TitTok service"} width={width} height={height}/>
    default:
      return null
  }
}

export const ServiceFormatter = memo(({servId}) => {
  return ServiceTypesImg(+servId);
});

export const ServiceText = (serviceType) => {
  switch (serviceType) {
    case 1:
    case "G":
      return serviceName.Google
    case 5:
    case "YA":
      return serviceName.Yandex
    case 3:
    case "F":
      return serviceName.Facebook
    case 4:
    case "TT":
      return serviceName.TikTok
    default:
      return ""
  }
}

export const ServiceOptions = (serviceTypes, width = "auto", height = 16, isBig = true) => {
  return serviceTypes.map(serviceType => {
    return {value: +serviceType, label: ServiceTypesImg(+serviceType, false, width, height, isBig), id: +serviceType}
  });
}